/* eslint-disable prefer-destructuring */
export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const WEB_ROOT = process.env.REACT_APP_WEB_ROOT;
export const S3_ROOT = process.env.REACT_APP_S3_ROOT;
export const unsplash_key = process.env.REACT_APP_UNSPLASH_KEY;
